import { getHeadlessUrl, NavigationType } from '@wix/wix-to-headless-redirect-client';
import { PageMap } from '@wix/wixstores-client-core';
import { SPECS } from '../../../constants';
export var toCart = function (_a) {
    var context = _a.context, origin = _a.origin;
    return function () {
        if (context.siteStore.experiments.enabled(SPECS.HeadlessRedirectToCart)) {
            var headlessUrl = getHeadlessUrl({
                query: context.siteStore.location.query,
                baseUrl: context.siteStore.location.baseUrl,
                navParams: { logicalName: NavigationType.ECOM_CART },
            });
            if (headlessUrl) {
                context.siteStore.navigateToLink({
                    url: headlessUrl,
                    sdkLink: {
                        url: headlessUrl,
                        target: '_top',
                        type: 'ExternalLink',
                    },
                });
                return Promise.resolve();
            }
        }
        return context.siteStore.navigate({
            sectionId: PageMap.CART,
            queryParams: { origin: origin },
        }, true);
    };
};
//# sourceMappingURL=toCart.js.map